import { Component, EventEmitter, Inject, OnInit, ViewChild } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_444';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Valor de la sanción  ', listHelp: ['444'] }
];

@Component({
  selector: 'app-descuentos-sancion-modal',
  templateUrl: './descuentos-sancion-modal.component.html',
  styleUrls: ['./descuentos-sancion-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class DescuentosSancionModalComponent extends HandlerModal implements OnInit {

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;
  constructor(
    public dialogRef: MatDialogRef<DescuentosSancionModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_431 == undefined)this.model.doc.cuerpo.cs_id_431 = "0";
    if(this.model.doc.cuerpo.cs_id_388 == undefined)this.model.doc.cuerpo.cs_id_388 = "0";
    if(this.model.doc.cuerpo.cs_id_389 == undefined)this.model.doc.cuerpo.cs_id_389 = "0";
    if(this.model.doc.cuerpo.cs_id_390 == undefined)this.model.doc.cuerpo.cs_id_390 = "0";
    if(this.model.doc.cuerpo.cs_id_391 == undefined)this.model.doc.cuerpo.cs_id_391 = "0";
    if(this.model.doc.cuerpo.cs_id_392 == undefined)this.model.doc.cuerpo.cs_id_392 = "0";
    if(this.model.doc.cuerpo.cs_id_430 == undefined)this.model.doc.cuerpo.cs_id_430 = "0";
  }
  
  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 431:
        this.operacionCs431();
        break;
    }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";
    
  }

  operacionCs431(){
    let resultado = "0";
    this.model.doc.cuerpo.cs_id_431 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_431,true);
    let cas385 = Number(this.model.doc.cuerpo.cs_id_385);
    if(cas385==1){
      resultado = "0";
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.model.doc.cuerpo.cs_id_127,"0.25", true); 
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultado,this.model.doc.cuerpo.cs_id_387, true); 
      resultado = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultado, "0")?"0":resultado;
      this.model.doc.cuerpo.cs_id_388 = this.dutilidades.redondearValorMoneda(resultado,true);
    }
    if(cas385==2){
      resultado = "0";
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.model.doc.cuerpo.cs_id_127,"0.50", true); 
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultado,this.model.doc.cuerpo.cs_id_387, true); 
      resultado = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultado, "0")?"0":resultado;
      this.model.doc.cuerpo.cs_id_389 = this.dutilidades.redondearValorMoneda(resultado,true);

      resultado = "0";
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cs_id_386,this.model.doc.cuerpo.cs_id_127, true); 
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, resultado,"2", true); 
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultado,"0.50", true); 
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultado,this.model.doc.cuerpo.cs_id_387, true); 
      resultado = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultado, "0")?"0":resultado;
      this.model.doc.cuerpo.cs_id_390 = this.dutilidades.redondearValorMoneda(resultado,true);

      resultado = "0";
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, this.model.doc.cuerpo.cs_id_389, this.model.doc.cuerpo.cs_id_390)){
        this.model.doc.cuerpo.cs_id_430 = this.model.doc.cuerpo.cs_id_389;
      }else{
        this.model.doc.cuerpo.cs_id_430 = this.model.doc.cuerpo.cs_id_390;
      }
    }
    if(cas385>2){
      resultado = "0";
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.model.doc.cuerpo.cs_id_127,"0.75", true); 
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultado,this.model.doc.cuerpo.cs_id_387, true); 
      resultado = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultado, "0")?"0":resultado;
      this.model.doc.cuerpo.cs_id_391 = this.dutilidades.redondearValorMoneda(resultado,true);
      
      resultado = "0";
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cs_id_386,this.model.doc.cuerpo.cs_id_127, true); 
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, resultado,"2", true); 
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultado,"0.70", true); 
      resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultado,this.model.doc.cuerpo.cs_id_387, true); 
      resultado = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultado, "0")?"0":resultado;
      this.model.doc.cuerpo.cs_id_392 = this.dutilidades.redondearValorMoneda(resultado,true);

      resultado = "0";
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, this.model.doc.cuerpo.cs_id_391, this.model.doc.cuerpo.cs_id_392)){
        this.model.doc.cuerpo.cs_id_430 = this.model.doc.cuerpo.cs_id_391;
      }else{
        this.model.doc.cuerpo.cs_id_430 = this.model.doc.cuerpo.cs_id_392;
      }
    }
    

  }

   ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {

  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  protected validateShowSave(){
    if (this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO){this.showSave=true;}
  }
  
  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/descuentos/descuentos-sancion-modal/descuentos-sancion-modal.component.ts